// document.addEventListener('DOMContentLoaded', function() {
//     // Handle buy now button click
//     document.querySelectorAll('.buy-now-button').forEach(button => {
//       button.addEventListener('click', function(e) {
//         if (this.hasAttribute('disabled')) return;
//         // Prevent default form submission
//         e.preventDefault();
//         // Get the form
//         const form = this.closest('form');
//         // Add a hidden input to indicate direct checkout
//         const directCheckoutInput = document.createElement('input');
//         directCheckoutInput.type = 'hidden';
//         directCheckoutInput.name = 'return_to';
//         directCheckoutInput.value = '/checkout';
//         form.appendChild(directCheckoutInput);
//         // Submit the form
//         form.submit();
//       });
//     });
//   });

 function buyNow(variantId) {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(() => {
          window.location.href = '/checkout';
        });
      });
  }